export default "__VITE_ASSET__AGo0B$1k__"